// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2XO5g","containerItemsCenter":"Skeleton_containerItemsCenter__v1X81"};